// Na een uitrol bestaan de losse stukken van de vorige versie niet meer op de
// server (Trendlaag-<oude hash>.js). Een browser die nog de oude versie draait,
// krijgt bij het openen van zo'n tab dan index.html terug in plaats van code, en
// het scherm valt om (03-11, Trends na de uitrol van #95). Eén keer de pagina
// herladen haalt de nieuwe versie op en lost het op.

const SLEUTEL = "sof.herladenNaUitrol";
// Binnen deze tijd niet nog eens herladen: is het stuk na herladen nog steeds
// weg, dan is er iets anders mis en blijft het foutscherm staan.
const RUST_MS = 60_000;

const PATRONEN = [
  /dynamically imported module/i, // Chrome, Edge, Firefox
  /Importing a module script failed/i, // Safari
  /Failed to load module script/i,
  /Unable to preload CSS/i, // Vite, een stylesheet van een los stuk
];

export function isOudeVersieFout(fout: unknown): boolean {
  const tekst = fout instanceof Error ? `${fout.name} ${fout.message}` : String(fout ?? "");
  return PATRONEN.some((p) => p.test(tekst));
}

/** Herlaadt de pagina, behalve als dat in de laatste minuut al gebeurde. Geeft terug of er herladen wordt. */
export function herlaadVoorNieuweVersie(nu: number = Date.now()): boolean {
  try {
    const vorige = Number(window.sessionStorage.getItem(SLEUTEL) ?? 0);
    if (nu - vorige < RUST_MS) return false;
    window.sessionStorage.setItem(SLEUTEL, String(nu));
  } catch {
    // Geen opslag (privévenster met blokkade): dan niet automatisch, de knop blijft.
    return false;
  }
  window.location.reload();
  return true;
}
